import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { useStore } from 'modules/Stores';
// services
import ChartSyncService from 'modules/ChartSync';
import Settings from 'modules/Settings/Settings';
import LoggerService from 'modules/Logger';
// typings
import { StorageOptions } from 'modules/ChartSync/typings';
// components
import { ChartSaveSettingsModal } from '../ChartSaveSettingsModal/ChartSaveSettingsModal';

const ChartSaveSettingsModalContainer = () => {
  const {
    toggleModal,
    modalsConfig: { chartSaveSettings },
  } = useStore('AppStore');
  const { isVerifying } = useStore('ChartSyncStore');
  const storageOption: StorageOptions = Settings.getIsChartSettingsSaveEnabled()
    ? 'cloudStorage'
    : 'localStorage';

    const handleSaveStorageOption = (seletedOption: StorageOptions) => {
      ChartSyncService.setSelectedStorageOption(seletedOption);
      try {
        ChartSyncService.verifyChartSyncBeforeInit();
      } catch (error: any) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        LoggerService.log('APP', error?.message);
      }
    };

  const handleClose = () => {
    if (isVerifying) return;
    toggleModal('chartSaveSettings');
  };

  return chartSaveSettings ? (
    <ChartSaveSettingsModal
      onClose={handleClose}
      handleSaveStorageOption={handleSaveStorageOption}
      optedStorageOption={storageOption}
      isSubmitting={isVerifying}
    />
  ) : (
    <Fragment />
  );
};

export default observer(ChartSaveSettingsModalContainer);
